enum AuthEndpoints {
  INVITE_KEY = '/invite-key',
  HANDOFF_CODE = '/handoff-code',
  HANDOFF_CODE_EXCHANGE = '/handoff-code/exchange',
  RESET_PASSWORD = '/reset-password',
  RESET_PASSWORD_COMPLETE = '/reset-password-complete',
  VALIDATE_RESET_CODE = '/validate-reset-code',
  SET_PASSWORD = '/set-password',
  ME = '/me',
  PORTAL_PROJECTS = '/portal/projects',
  PORTAL_PROFILE = '/portal/profile',
  PORTAL_AVATAR = '/portal/avatar',
  PORTAL_STAMP_OPENED = '/portal/stamp-opened',
  PORTAL_PROJECT_REQUEST = '/portal/project-request',
  PHONE_VERIFICATION = '/phone/verification',
}

export default AuthEndpoints
